export const POST_ALLEYE_SALES = 'POST_ALLEYE_SALES';
export const POST_ALLEYE_SALES_SUCCESS = 'POST_ALLEYE_SALES_SUCCESS';
export const POST_ALLEYE_SALES_FAILED = 'POST_ALLEYE_SALES_FAILED';
export const LOADING_ALLEYE_SALES = 'LOADING_ALLEYE_SALES';
